import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FormattedMessage } from 'react-intl';

import SalesItemTable from './SalesItemTable';

import './SalesItems.css';

const CHEMICAL_DATA = [
  {
    title: `SYNTHETIC RUBBER`,
    items: [
      [`ASAHI KASEI`, `S-SBR (SOLUTION STYRENE-BUTADIENE RUBBER)`, `TUFDENE SERIES, ASAPRENE SERIES`],
      [``, `BR (POLYBUTADIENE RUBBER)`, `ASADENE SERIES`],
      [``, `SBC (CLEAR STYRENIC COPOLYMERS)`, `ASAFLEX SERIES`],
      [``, `SEBS (HYDROGENATED STYRENIC ELASTOMER)`, `TUFTEC SERIES`],
      [``, `SBS (STYRENIC THERMOPLASTIC ELASTOMER)`, `TUFPRENE SERIES, ASAPRENE SERIES`],
      [``, `H-SBR`, `S.O.E. SERIES`],
      [``, ``, ``],
      [``, ``, ``],
      [`UBE INDUSTRIES`, `BR (POLYBUTADIENE RUBBER)`, `UBEPOL BR SERIES`],
      [``, `VCR (VINYL CIS RUBBER)`, `UBEPOL VCR SERIES`],
      [``, ``, ``],
      [``, ``, ``],
      [`NIPPON ZEON`, `ISOPRENE RUBBER`, `NIPOL – IR SERIES`],
    ]
  },
  {
    title: `ELASTOMER`,
    items: [
      [`TOSOH`, `EVA(ETHYLENE VINYLACETATE COPLYMER)`, `NIPOFLEX SERIES`],
    ]
  },
  {
    title: `REINFORCING FILLERS & ADDITIVE`,
    items: [
      [`SHIRAISHI KOGYO`, `CaCO₃ (PRECIPITATED CALCIUM CARBONATE)`, `HAKUENKA SERIES, VISCOLITE SERIES`],
      [``, ``, `HOMOCAL SERIES, VIGOT SERIES`],
      [``, ``, `BRILLIANT SERIES`],
      [``, ``, `VISCOEXCEL30, TUNEX-E, SILVER-W`],
      [``, ``, ``],
      [``, ``, ``],
      [`BIHOKU FUNKA`, `CaCO₃ (GROUND CALCIUM CARBONATE)`, `WHITON SERIES, LIGHTON SERIES`],
      [`NAIKAI SALT INDUSTRIES`, `MgCO₃ (MAGNESIUM CARBONATE)`, `BALL-TT`],
      [`TOKUYAMA`, `SiO₂ (FUMED SILICA)`, `REOLOSIL SERIES`],
      [`SAKAI CHEMICAL`, `TiO₂ (TITANIUM DIOXIDE)`, `TITONE R-25`],
      [`NOF CORPORATION`, `DICUMYL DIOXIDE`, `PERCUMYL D`],
    ]
  },
  {
    title: `FINE CHEMICAL`,
    items: [
      [`TOKUYAMA`, `PHOTOCHROMIC LENS MONOMER`, `TRANSHADE-364`],
      [``, `PIGMENT OF PHOTOCHROMIC LENS`, `CNN SERIES`],
      [``, ``, ``],
      [`SANYO KASEI`, `SPINNING OIL FOR NYLON FILAMENT`, `KLN SERIES`],
      [``, `SPINNING OIL FOR POLYESTER FILAMENT`, `EF-800`],
    ]
  },
  {
    title: `FOOD ADDITIVE`,
    items: [
      [`SHIRAISHI CALCIUM`, `CaCO₃ (PRECIPITATED CALCIUM CARBONATE)`, `COLLOCALSO-EX, COLLOCALSO-MG`],
      [``, ``, `CALESSEN-A, PORECAL-N`],
      [``, `CaCO₃ (NATURAL CALCIUM CARBONATE)`, `COLLOCALSO-WB , WHITON-F`],
      [``, ``, ``],
      [`NAIKAI SALT INDUSTRIES`, `MgCO₃ (MAGNESIUM CARBONATE)`, `BALL-TT (food grade)`],
    ]
  },
  {
    title: `AGRICULTURAL CHEMICAL`,
    items: [
      [`SHIRAISHI CALCIUM`, `CALCIUM FERTILIZER`, `CELLBINE`],
      [``, `BINDER OF AGRICULTURAL CHEMICALS`, `MOWINYL-POWDER 845`],
    ]
  },
  {
    title: `ELECTRO MATERIAL`,
    items: [
      [`MEC COMPANY LTD.`, `MECBRITE`, `CA-5330A`],
      [``, ``, `CA-5370`],
      [``, ``, `CA-5330 series`],
      [``, ``, `CA-5302`],
      [``, ``, `CA-5372`],
      [``, ``, `CB-5000 series`],
      [``, ``, `CB-5602AY, CB-801Y`],
      [``, ``, `CB-5552A`],
      [``, ``, `CI-7200 series`],
      [``, ``, `EXE series`],
      [``, ``, `SF-5420`],
      [``, ``, `CAU-5232C`],
      [``, ``, `CAU-5214, CAU-5216, CAU-5220`],
      [``, ``, `QE-7300`],
      [``, ``, ``],
      [``, `MECetchBOND`, `CL-8300 series`],
      [``, ``, `CZ-8000 series`],
      [``, ``, `CZ-8100, CZ-8101`],
      [``, ``, `CZ-8500`],
      [``, ``, `STZ-3100`],
      [``, ``, `UT series`],
      [``, ``, ``],
      [``, `MEC V-Bond`, `BO-7790V`],
      [``, ``, ``],
      [``, `MEC REMOVER`, `CH series`],
      [``, ``, `S-1728`],
      [``, ``, `S-651A, S-651B`],
      [``, ``, `S-1022`],
      [``, ``, `NH-1860 series`],
      [``, ``, `PJ-9720`],
      [``, ``, ``],
      [``, `MEC PowerETCH`, `HE-7000Y`],
      [``, ``, `HE-7002A`],
      [``, ``, ``],
      [``, `MEC ALBRITE`, `AS-1250`],
      [``, ``, ``],
      [``, `MEC NICKEL ROUGHENER`, `NR-1870`],
      [``, ``, ``],
      [``, `FlatBOND`, `GT Process`],
      [``, ``, ``],
      [``, `RESIN TO METAL`, `AMALPHA`],
      [``, ``, ``],
      [``, ``, ``],
      [`AJINOMOTO FINE-TECHNO CO., INC.`, `BUILD-UP MATERIAL`, `ABF-SERIES`],
      [``, `MOLDING MATERIAL`, `LE-SERIES`],
      [``, ``, `MI-SERIES`],
      [``, `ADHESIVE MATERIAL`, `AE-SERIES`],
      [``, `ENCAPSULATION MATERIAL`, `AT-SERIES`],
      [``, `(Under development)`, `KD-SERIES`],
      [``, ``, ``],
      [``, ``, ``],
      [`NODA SCREEN CO., LTD.`, `PCB PROCESSING`, `VACUUM PRINTER VE-6500`],
      [``, ``, `HOLE PLUGGING SERVICE`],
      [``, ``, ``],
      [``, `CHEMICAL`, `INT SERIES`],
      [``, ``, `WOP SERIES`],
      [``, ``, `PCH SERIES`],
      [``, ``, `OPC SERIES`],
      [``, ``, `No. SERIES`],
      [``, ``, ``],
      [`TATSUTA ELECTRIC WIRE & CABLE CO., LTD.`, `Via filling Paste`, `DD paste AE2217 / AE1244 / AE3030`],
      [``, `Via filling Paste( Non coductive )`, `DD paste AE1125DS / AE1125HD`],
      [``, `Metalize Paste`, `MPA500, MP8300`],
      [``, `Conductive Copper Paste`, `DD paste NF2000EX`],
      [``, `Conductive Paste`, `SW150`],
      [``, `EMI Shield Spray Paste`, `Under Development`],
      [``, ``, ``],
    ]
  },
];

const MACHINERY_DATA = [
  {
    title: `IMPORT`,
    items: [
      [`KOBE STEEL`, `* TIRE∙RUBBER MACHINERY`, `BANBURY MIXER,   ROLLER HEAD EXTRUDER(TSR)`],
      [``, ``, `TIRE TESTING MACHINE`],
      [``, ``, `TIRE UNIFORMITY MACHINE`],
      [``, ``, ``],
      [``, `* COMPRESSOR`, `COMPRESSOR (ORDER MADE)`],
      [``, ``, ``],
      [``, `* EQUIPMENT`, `COLD BOX, VAPORIZER, ALEX, DHCE, ETC`],
      [``, ``, ``],
      [``, `* PLASTIC PROCESSING MACHINE`, `TWIN SCREW EXTRUDER(KTX)`],
      [``, ``, ``],
      [``, ``, ``],
      [`NAKATA ENGINEERING`, `* TIRE∙RUBBER MACHINERY`, `EXTRUDER(SINGLE, DUPLEX, TRIPLEX, QUADRUPLEX, QUINTUPLEX, CHIMNEY)`],
      [``, ``, `AUTO BEAD FILLER LINE (GP APEXER)`],
      [``, ``, `ROLLER HEAD EXTRUDER (INNER LINER)`],
      [``, ``, ``],
      [``, ``, ``],
      [`YAMATO SCALE`, `* INDUSTRIAL SCALES`, `AUTO CONSECUTIVE TREAD RUBBER SCALE,  WEIGHING SYSTEM`],
      [``, ``, ``],
      [``, `* TIRE MACHINE`, `TIRE TEST MACHINE`],
      [``, ``, ``],
      [`SUMITOMO SEIKA`, `* GAS ENGINEERING`, `PSA NITROGEN GAS GENERATORS (질소가스회수장치)`],
      [``, ``, ``],
      [``, ``, ``],
      [`NAGAHAMA`, `* TIRE MACHINERY`, `TIRE DYNAMIC BALANCING MACHINE`],
      [``, ``, ``],
      [``, ``, ``],
      [`NIPPON ROLL`, `* MACHINERY ROLL`, `MIXING CALENDER ROLL`],
      [``, ``, `MILL SYSTEM`],
    ]
  },
  {
    title: `EXPORT`,
    items: [
      [`KOBE STEEL`, `* COMPRESSOR (SCREW. TURBO, RECIPRO)`, `COMPRESSOR PACKAGE, OIL & GAS UNIT, HEAT EXCANGER, HIGH SPEED GEAR, REDUCE GEAR, PRESSURE VESSEL, FILTER, MOTOR, PUMP, FLANGE, FTTING, PIPING, VALVE, LEVEL GAUGE, TRANSMITTER, HEATER, BOLT & NUT, OTHERS OF COMPRESSOR PART. `],
      [``, ``, ``],
      [``, ``, ``],
      [`MISUZU`, `* UNIT PACKAGE`, `MOTOR, FILTER, VALVE, PIPE, FLANGE, FITTING, GAUGE, OTHERS OF UNIT PART`],
      [``, ``, ``],
      [``, ``, ``],
      [`KOWA `, `* UNIT PACKAGE`, `MOTOR, FILTER, VALVE, PIPE, FLANGE, FITTING, GAUGE, OTHERS OF UNIT PART`],
      [``, ``, ``],
      [``, ``, ``],
      [`FUJI TECH `, `* UNIT PACKAGE`, `MOTOR, FILTER, VALVE, PIPE, FLANGE, FITTING, GAUGE, OTHERS OF UNIT PART`],
      [``, ``, ``],
      [``, ``, ``],
      [`FUKUI SANGYO `, `* COMPRESSOR & UNIT PACKAGE`, `MOTOR, FILTER, VALVE, PIPE, FLANGE, FITTING, GAUGE, OTHERS OF UNIT PART`],
    ]
  },
];

export default class SalesItems extends React.Component {
  
  static propTypes = {
    className: PropTypes.string
  };

  render() {
    return (
      <div className={classnames('SalesItems', this.props.className)}>
        <SalesItemTable
          data={CHEMICAL_DATA}
          title={<FormattedMessage id="SalesItems.chemicalTitle"/>}
          columnHeaders={[
            <FormattedMessage id="SalesItems.Manufacturer"/>,
            <FormattedMessage id="SalesItems.chemicalName"/>,
            <FormattedMessage id="SalesItems.materialName"/>
          ]}
        />
        <SalesItemTable
          className="SalesItems__machineryTable"
          data={MACHINERY_DATA}
          title={<FormattedMessage id="SalesItems.machineryTitle"/>}
          columnHeaders={[
            <FormattedMessage id="SalesItems.Manufacturer"/>,
            <FormattedMessage id="SalesItems.division"/>,
            <FormattedMessage id="SalesItems.machine"/>
          ]}
        />
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/SalesItems.js